var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      {
        staticClass:
          "py-4 px-6 flex items-center justify-between border-b border-slate-400"
      },
      [
        _c("BlTextSubtitle2", {
          staticClass: "text-slate-700",
          attrs: { text: "Share this report" }
        }),
        _vm._v(" "),
        _c("BlIcon", {
          staticClass: "h-6 w-6",
          attrs: { icon: "close", clickable: "" },
          on: {
            clicked: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "py-4 px-6 flex flex-col gap-3" },
      [
        _c("BlTextBody2", {
          attrs: {
            text:
              "Your report has been successfully published! You can now share it with others via the provided link or QR code."
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "relative cursor-pointer",
            on: { click: _vm.onCopyToClipboard }
          },
          [
            _c("BlInputText", {
              staticClass: "pr-8 cursor-pointer",
              attrs: { input: _vm.linkInput }
            }),
            _vm._v(" "),
            _c("BlIcon", {
              staticClass: "absolute top-2 right-4 h-6 w-6",
              attrs: { icon: "copy", color: "slate-8" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "py-4 flex justify-center" },
          [
            _c("QrcodeVue", {
              attrs: { value: _vm.linkInput.model, size: 200, level: "L" }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0de8675c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de8675c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/helper/ShareReport.vue
// module id = null
// module chunks = 